// @ts-ignore
import { useSelector } from 'react-redux';
import { getMenuItems } from '../selectors/navigation';

export const getMenu = () => useSelector(getMenuItems);
